import React from "react"
import { Helmet } from "react-helmet-async"
import { getFullUrl } from "../utils/getFullUrl"
import ogImageUrl from "../assets/img/og-image.png"

export const SEO = ({
  title = "Zombie TD",
  description = null,
  ogTitle = null,
  ogDescription = null,
  ogImage = null,
  ogUrl = null,
  // keywords = "zombie, tower defense, game, nft",
  // canonical = null,
}) => {

  const fullOgImageUrl = ogImage ? getFullUrl(ogImage) : getFullUrl(ogImageUrl)
  const fullOgUrl = getFullUrl(ogUrl)

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {/*<meta name="keywords" content={keywords} />*/}

      {/* Open Graph tags */}
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={fullOgImageUrl} />
      {ogUrl && <meta property="og:url" content={fullOgUrl} />}
      <meta property="og:type" content="website" />

      {/* Twitter Card tags */}
      {/*<meta name="twitter:card" content="summary_large_image" />*/}
      {/*<meta name="twitter:title" content={ogTitle || siteTitle} />*/}
      {/*<meta name="twitter:description" content={ogDescription || description} />*/}
      {/*{ogImage && <meta name="twitter:image" content={ogImage} />}*/}

      {/* Canonical URL */}
      {/*{canonical && <link rel="canonical" href={canonical} />}*/}
    </Helmet>
  )
}
